/**
 * Uses the law of cosines to calculate the third side of a triangle (imagined inside the slice) given
 * the other two sides and one of the angles of imagined triangle.
 * Law of Cosines: https://en.wikipedia.org/wiki/Law_of_cosines
 *
 * @param sliceRadiansDiff - How much 'angle' is in this triangle in radians.
 * @param radius - the length of the sides (radius for a circle).
 *
 * @returns The other side of the triangle given by the Law of Cosines.
 */
export const sliceAngleDistance = (sliceRadiansDiff: number, radius: number) =>
  Math.sqrt((1 - Math.cos(sliceRadiansDiff)) * 2 * Math.pow(radius, 2));
